import template from './emoji-selector.pug';
import { Picker } from 'emoji-picker-element';

export const EmojiSelectorComponent = {
  template,
  bindings: {
    emoji: '<',
    onSelect: '&'
  },
  transclude: true,
  controller: class EmojiSelectorComponent {
    constructor($sce, $element) {
      'ngInject';
      this.$sce = $sce;
      this.$element = $element;
      this.picker = null;
    }

    $onChanges(changes) {
      if (changes.emoji) {
        this.setEmoji(changes.emoji.currentValue);
      }
    }

    $onInit() {
      this.setEmoji(this.emoji);
    }

    openSelector() {
      // this.close();
      this.createPicker();
    }

    closeEmojiPicker(event) {
      if (this.picker && !this.$element[0].contains(event.target)) {
        this.picker.remove();
        this.picker = null;
      }
    }

    createPicker() {
      if (this.picker) {
        return;
      }
      this.picker = new Picker();
      this.$element.find('.emoji').append(this.picker);
      this.picker.addEventListener('emoji-click', this.select.bind(this));
      // on blur close the picker
      document.addEventListener('click', this.closeEmojiPicker.bind(this));
    }

    setEmoji(emoji) {
      this.emoji = emoji;
      this.$element.parent().find('.emoji').html(emoji);
    }

    select(event) {

      console.log('event', event);
      this.setEmoji(event.detail.unicode);
      this.picker.remove();
      this.picker = null;
      this.onSelect({
        $event: { emoji: this.emoji }
      });
    }
  }
};
